import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  structuredData?: object;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  robots?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  canonical,
  ogImage = '/img/logo_new.png',
  ogType = 'website',
  structuredData,
  author = 'Patrycja i Grzegorz Pabich',
  publishedTime,
  modifiedTime,
  robots = 'index, follow'
}) => {
  const fullTitle = `${title} | Gabinet Fizjofit w Reczu | P.G. Pabich`;
  const fullCanonical = canonical ? `https://www.fizjoterapia-pabich.pl${canonical}` : 'https://www.fizjoterapia-pabich.pl';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="author" content={author} />
      <meta name="robots" content={robots} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />
      
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={`https://www.fizjoterapia-pabich.pl${ogImage}`} />
      <meta property="og:site_name" content="Fizjofit - Gabinet Fizjoterapii w Reczu" />
      <meta property="og:locale" content="pl_PL" />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`https://www.fizjoterapia-pabich.pl${ogImage}`} />
      
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
